import { cva } from '@/styled-system/css';

export const textButtonRootRecipe = cva({
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    gap: 'tighter',
    focusOutline: true,
  },

  variants: {
    tone: {
      'brand': {},
      'neutral': {},
      'neutral-fixed': {},
      'critical': {},
      'subtle': {},
    },
    disabled: {
      true: {
        opacity: 'disabled',
        cursor: 'default',
      },
      false: {},
    },
    onImpact: {
      true: {},
      false: {},
    },
    isGrouped: {
      true: {
        textAlign: 'center',
        alignSelf: 'stretch',
      },
      false: {},
    },
    size: {
      sm: {},
      md: {},
      lg: {},
    },
    textStyle: {
      'body': {},
      'body-bold': {},
      'body-sm': {},
      'body-sm-bold': {},
    },
  },

  compoundVariants: [
    {
      isGrouped: true,
      size: 'sm',
      css: {
        paddingInline: 'default',
      },
    },
    {
      isGrouped: true,
      size: 'md',
      css: {
        paddingInline: 'default',
      },
    },
    {
      isGrouped: true,
      size: 'lg',
      css: {
        paddingInline: 'default',
      },
    },
  ],
});
